import React from "react";
import { Container } from "react-bootstrap";
import Link from "components/link";
import * as styles from "./styles.mod.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import Image from "components/image";

SwiperCore.use([Pagination]);
const RecipesAuthors = ({ authors }) => {

  let settings = {
    slidesPerView: 2.8,
    spaceBetween: 10,
    loop: false,
    dots: true,
    autoHeight: true,
    pagination: { clickable: true },
    navigation: { clickable: true },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,

      },
      1200: {
        spaceBetween: 25,
        slidesPerView: 4,
      }
    }
  };

  return (
    <Container>
      <div className={`${styles.recipesAuthors} ${styles.desktopView}`}>
        {authors?.map((data, i) => {
          return (
            <div key={i} className={styles.singleAuthor}>
              <Link to={`/author/${data?.handle}`}>
                <Image image={data?.image} />
                <div className={styles.authorsData}>
                  <p className={styles.name}>{data?.title}</p>
                  <p className={styles.position}>{data?.position}</p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>

      <div className={`${styles.recipesAuthors} ${styles.mobileView}`}>
        <Swiper {...settings}>
          {authors?.map((data, i) => {
            return (
              <SwiperSlide key={i}>
                <div className={styles.singleAuthor}>
                  <Link to={`/author/${data?.handle}`}>
                    <Image image={data?.image} />
                    <div className={styles.authorsData}>
                      <p className={styles.name}>{data?.title}</p>
                      <p className={styles.position}>{data?.position}</p>
                    </div>
                  </Link>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </Container>
  );
};

export default RecipesAuthors;